module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-41.0927d6fb.png";